import { FORM_VALUES } from '../../../../constants';

export const FIELD_NAME = FORM_VALUES.title;

export const TITLE_RESTRICTED_SYMBOLS = ['/', '%'];
export const TITLE_PATTERN = new RegExp(
  `^[^${TITLE_RESTRICTED_SYMBOLS.join('')}]+$`
);
export const TITLE_MAX_LENGTH = 100;
